// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="customer-deposit-accounts-cash-action" class="box product-operation" ng-if="\$ctrl.termDeposit">

  <sub-header header="'Close term deposit'"></sub-header>

  <div class="info info--deposit">
    <div class="info-detail">
      <span class="key">Product name:</span>
      <span class="value">{{\$ctrl.productDefinition.productName}}</span>
    </div>
    <div class="info-detail">
      <span class="key">Available balance:</span>
      <span class="value"
            ng-class="{'currency--positive': \$ctrl.termDeposit.balance > 0, 'currency--negative': \$ctrl.termDeposit.balance < 0}">
          {{\$ctrl.termDeposit.balance | nxCurrency}}
        </span>
    </div>
  </div>

  <h2 class="section-header">Please confirm the following:</h2>
  <form name="\$ctrl.transactionForm">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>Gross interest:</td>
        <td>
          <cash ng-disabled="true" ng-model="\$ctrl.termDeposit.accruedInterest"></cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Withholding tax:</td>
        <td>
          <cash ng-disabled="true" ng-model="\$ctrl.termDeposit.accruedWithholdingTax"></cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Net interest:</td>
        <td>
          <cash ng-disabled="true" ng-model="\$ctrl.termDeposit.accruedInterestNet"></cash>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="buttons">
      <signature-card
        file-id="\$ctrl.termDeposit.signatureCardFileId"
        product-group="'DEPOSIT'"
        product-status="\$ctrl.termDeposit.status"></signature-card>
      <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
      <button type="submit" class="btn btn-danger" ng-click="\$ctrl.close()">
        Close
      </button>
    </div>
  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/close-term-deposit/close-term-deposit.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;